<template>
  <div class="open-time">
    <h1 class="m-font-1">餐吧及其他设施</h1>
    <div class="open-content">

      <div class="pl-20 mb-40">
        <div class="mb-20">
          <div class="date mb-10">观众餐吧</div>
          <div class=" fs-16 mb-10">观众餐厅</div>
          <div class="week mb-10">博物馆一层6号展厅东侧</div>
          <div class="week">营业时间｜周二至周日：09:00～17:00，周一休息。</div>

        </div>
        <div class="box">
          <div class="box_inner mr-40">
            <img src="../../assets/images/canting.png" alt="">
          </div>

          <div class="box_inner">
            <img src="../../assets/images/canting2.png" alt="">

          </div>
        </div>
      </div>

      <div class="pl-20 mb-40">
        <div class="mb-20">
          <div class=" fs-16 mb-10">观众水吧</div>
          <div class="week mb-10">博物馆二楼西侧</div>
          <div class="week">营业时间｜周二至周日：09:00～17:00，周一休息（现暂停营业）。</div>

        </div>
        <div class="box">
          <div class="box_inner mr-40">
            <img src="../../assets/images/shuiba.png" alt="">

          </div>

          <div class="box_inner">
            <img src="../../assets/images/shuiba2.png" alt="">
          </div>
        </div>
      </div>

      <div class="pl-20 mb-40">
        <div class="mb-20">
          <div class="date mb-10">行李寄存处</div>
          <div class="week mb-10">辽宁省博物馆在一楼艺术品商店北侧设有行李寄存处。</div>
        </div>
        <div class="box">
          <div class="box_inner mr-40">
            <img src="../../assets/images/baggage1.png" alt="">

          </div>

          <div class="box_inner">
            <img src="../../assets/images/baggage2.png" alt="">
          </div>
        </div>
      </div>

      <div class="pl-20 mb-40">
        <div class="mb-20">
          <div class="date mb-10">无障碍设施</div>
          <div class="week mb-10">辽宁省博物馆设有无障碍电梯及无障碍洗手间，同时提供轮椅借用。</div>
        </div>
        <div class="box">
          <div class="left">
            <div class="left-inner">
              <img :src="defaultBg" :class="{'floor3':chooseId == 1}" alt="">
            </div>
            <div class="floor-wrapper">
              <span v-for="(item, index) in floorList" :key="index" :class="{'active':index==chooseId}"
                @click="changeFloor(item, index)">{{ item.name }}</span>
            </div>
          </div>

          <div class="flex-1 ml-40">
            <div class="wza-wrapper">
              <img class="lift" src="../../assets/images/icon_lift@2x.png" alt="">
              <span>无障碍电梯</span>
            </div>

            <div class="wza-wrapper">
              <img class="toilet" src="../../assets/images/icon_toilet@2x.png" alt="">
              <span>无障碍洗手间</span>
            </div>

            <div class="wza-wrapper">
              <img class="chair" src="../../assets/images/icon_rolling chair@2x.png" alt="">
              <span>轮椅借用</span>
            </div>
          </div>
        </div>
      </div>

      <div class="pl-20 mb-40">
        <div class="mb-20">
          <div class="date mb-10">无线网络</div>
          <div class="subtitle mb-10">辽宁省博物馆提供免费无线网络。</div>
          <div class="week line-wrapper mb-10">网络名称<span class="line"></span>LNSBWG</div>
          <div class="week  line-wrapper mb-10">连接密码<span class="line"></span>00000000</div>

        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {

  data() {
    return {
      chooseId: 0,
      defaultBg: require('../../assets/images/pic_1f@2x.png'),
      floorList: [{ id: 1, name: '1F', img: require('../../assets/images/pic_1f@2x.png') }, { id: 2, name: '2F', img: require('../../assets/images/pic_2f@2x.png') }, { id: 3, name: '3F', img: require('../../assets/images/pic_3f@2x.png') }],
    };
  },

  mounted() {

  },

  methods: {
    changeFloor(obj, dx) {
      this.defaultBg = obj.img
      this.chooseId = dx
    }
  },
};
</script>

<style lang="scss" scoped>
.open-time {
  width: 100%;
  h1 {
    margin-bottom: 60px;
    // font-size: 44px;
    font-weight: 400;
    color: #000000;
  }

  // .pl-20 {
  //   padding-left: 20px;
  // }

  .open-content {
    .date {
      font-size: 28px;
      font-weight: 400;
      color: #000000;
      margin-bottom: 40px;
    }

    .subtitle {
      font-size: 20px;
      font-weight: 400;
      color: #000000;
      margin-bottom: 20px;
    }
    .box {
      display: flex;
      .left {
        flex-shrink: 0;
        flex-basis: 776px;
        height: 632px;
        .left-inner {
          height: 560px;
          box-sizing: border-box;
          background: #f6f6f6;
          text-align: center;
          padding: 30px 0 37px;
          img {
            width: 578px;
            height: 493px;
            &.floor3 {
              width: 578px;
              height: 509px;
            }
          }
        }

        .floor-wrapper {
          margin-top: 16px;
          display: flex;
          border: 1px solid rgba($color: #312f2e, $alpha: 0.2);
          height: 56px;
          background: #f6f6f6;
          line-height: 56px;
          span {
            flex: 1;
            display: inline-block;
            text-align: center;
            font-size: 44px;
            font-weight: 400;
            color: #af844e;
            cursor: pointer;

            &.active {
              background: #af844e;
              color: #fff;
            }
          }
        }
      }
      .box_inner {
        flex: 1;
        height: 360px;
        // border: 1px solid rgba(215, 215, 215, 1);
        border-radius: 5px;
        color: #000;
        font-size: 16px;
        position: relative;
        &.mr-40 {
          margin-right: 40px;
        }
        img {
          width: 100%;
          height: 100%;
        }
        .floor-wrapper {
          position: absolute;
          bottom: 10px;
          left: 50%;
          transform: translateX(-50%);
          span {
            display: inline-block;
            background: #fff;
            font-size: 14px;
            padding: 4px 16px;
            cursor: pointer;
            &:first-child {
              border-radius: 3px 0 0 3px;
            }

            &:last-child {
              border-radius: 0 3px 3px 0;
            }

            &:hover {
              color: #af8653;
            }

            &.active {
              color: #af8653;
            }
          }
        }
      }

      .wza-wrapper {
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        font-size: 20px;
        font-weight: 400;
        color: #010101;
        img {
          width: 43px;
          height: 35px;
          margin-right: 20px;
        }
      }
      .flex-1 {
        flex: 1;
        padding: 40px;
        margin-left: 40px;
        height: 632px;
        box-sizing: border-box;
        background: #f6f6f6;
      }
      h2 {
        color: #bfa057;
        margin-bottom: 10px;
        font-size: 16px;
      }
    }

    .week,
    .close {
      color: #000;
      font-size: 16px;
    }

    .fs-16 {
      color: #000;
      font-size: 24px;
    }

    .line-wrapper {
      display: flex;
      align-items: center;
      line-height: 16px;
      .line {
        display: inline-block;
        width: 2px;
        height: 16px;
        margin: 0 10px;
        background: rgba($color: #000000, $alpha: 0.9);
      }
    }

    .close {
      display: flex;
      align-items: center;
      &::before {
        content: '';
        display: block;
        background: #333;
        width: 1px;
        height: 12px;
        margin-right: 6px;
      }
    }
  }
}
</style>